import { render, staticRenderFns } from "./WidgetNotifications.vue?vue&type=template&id=00415643&lang=pug&"
import script from "./WidgetNotifications.vue?vue&type=script&lang=js&"
export * from "./WidgetNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports